import React from 'react';
import { withPrefix } from 'gatsby';
import * as styles from './FooterLogoSection.module.css';
import Image from '../../common_ui/Image';

const FooterLogoSection: React.FC = () => {
  return (
    <div className={styles.logoSection}>
      <Image
        src="/svg/logo_on_navigation.svg"
        alt="プレコンセプションケア" 
        className={styles.logo}
      />
    </div>
  );
};

export default FooterLogoSection;
